var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.icon
    ? _c("img", {
        attrs: {
          src: _vm.icon,
          alt: _vm.sentiment,
          width: _vm.size,
          height: _vm.size,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }